import React from 'react';
import ImageGallery from 'react-image-gallery';
import LazyImage from '../../pages/component/LazyImage';

const GalleryRenderer = ({ comp }) => {
    const [aspectRatio, setAspectRatio] = React.useState(null);
    const [isFullscreen, setIsFullscreen] = React.useState(false);

    React.useEffect(() => {
        if (comp.type === 'gallery' && comp.images && comp.images.length > 0) {
            const firstImage = comp.images[0];
            const img = new Image();
            img.onload = () => {
                setAspectRatio(img.width / img.height);
            };
            img.src = firstImage.src;
        }
    }, [comp]);

    if (comp.type === 'gallery') {
        if (!aspectRatio) {
            return (
                <div className="img-spinner" style={{ width: '100%', aspectRatio: '4 / 3' }} />
            );
        }
        const images = (comp.images || []).map(img => {
            const thumbnail = img.src.replace(/(\.[^.]+)$/, '_thumb$1');
            return {
                original: img.src,
                thumbnail: thumbnail,
                description: comp.showImageTitles === false ? '' : (img.title || ''),
                title: img.title
            };
        });

        const imgStyle = { aspectRatio, width: '100%', height: 'auto', objectFit: 'cover', display: 'block' };

        const renderItem = (item) => {
            const src = isFullscreen ? item.original : item.thumbnail;
            return (
                <div className="image-gallery-image">
                    <LazyImage
                        src={src}
                        alt={item.title}
                        imgStyle={imgStyle}
                    />
                    {item.description && (
                        <span className="image-gallery-description">
                            {item.description}
                        </span>
                    )}
                </div>
            );
        };

        return (
            <div style={{ width: '100%' }}>
                <style>{`
                    .image-gallery-fullscreen-button {
                        top: 0;
                        right: 0;
                        bottom: auto;
                    }
                    .image-gallery-fullscreen-button .image-gallery-svg {
                        height: 28px;
                        width: 28px;
                    }
                `}</style>
                <ImageGallery
                    items={images}
                    showNav={comp.showNav ?? false}
                    autoPlay={comp.autoPlay ?? true}
                    slideInterval={(comp.slideIntervalSeconds ?? 7) * 1000}
                    showFullscreenButton={comp.showFullScreenButton ?? true}
                    showPlayButton={false}
                    showThumbnails={comp.showThumbnails ?? false}
                    additionalClass="fixed-height-gallery"
                    renderItem={renderItem}
                    onScreenChange={(full) => setIsFullscreen(full)}
                />
            </div>
        );
    }
    return null;
};

export default GalleryRenderer;
